import { useEffect, useState } from "react";
import { PROPERTIES, PROPERTY_ORDER } from "@/data/site";
import { getPropertyContent } from "@/lib/api";

// Merges owner edits (saved in the owner area) over the defaults in site.js
const ordered = [...PROPERTIES].sort(
  (a, b) => PROPERTY_ORDER.indexOf(a.slug) - PROPERTY_ORDER.indexOf(b.slug)
);

export const useProperties = () => {
  const [properties, setProperties] = useState(ordered);

  useEffect(() => {
    getPropertyContent()
      .then(({ data }) => {
        setProperties(ordered.map((p) => ({ ...p, ...(data[p.slug] || {}) })));
      })
      .catch(() => setProperties(ordered));
  }, []);

  return properties;
};

export default useProperties;
